import { createContext, useContext, useState, useEffect } from "react";

const AnimationContext = createContext();

export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error("useAnimation must be used within AnimationProvider");
  }
  return context;
};

export const AnimationProvider = ({ children }) => {
  const [animationStarted, setAnimationStarted] = useState(false);

  useEffect(() => {
    // Start the global animation timer as soon as the page loads
    const timer = setTimeout(() => {
      setAnimationStarted(true);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimationContext.Provider value={{ animationStarted }}>
      {children}
    </AnimationContext.Provider>
  );
};
